import { useMemo } from 'react';
import { Alert, SimpleGrid } from '@mantine/core';
import type { ComponentProjectMetricsResponse } from '../../../../types/dashboard';
import { ComponentProjectMetricChartCard } from '../ComponentProjectMetricChartCard';
import { expandGaceMetricsForCharts } from './mapGaceComponentProjectData';

type GaceComponentProjectMetricsProps = {
  data: ComponentProjectMetricsResponse;
};

export function GaceComponentProjectMetrics({ data }: GaceComponentProjectMetricsProps) {
  const metricsToRender = useMemo(() => expandGaceMetricsForCharts(data), [data]);

  if (metricsToRender.length === 0) {
    return (
      <Alert color="blue" variant="light">
        No G-ACE component project metrics are available yet.
      </Alert>
    );
  }

  return (
    <SimpleGrid
      cols={2}
      spacing="lg"
      breakpoints={[{ maxWidth: 1200, cols: 1 }]}
      sx={{ alignItems: 'stretch' }}
    >
      {metricsToRender.map(({ key, metric }) => (
        <ComponentProjectMetricChartCard key={key} metric={metric} />
      ))}
    </SimpleGrid>
  );
}
